<p-dialog [(visible)]="displayModal" [modal]="true" [style]="{ width: '90%', maxWidth: '880px' }" [closable]="true"
    (onHide)="close()" [breakpoints]="{ '960px': '95vw', '640px': '98vw' }">
    <ng-template #header>
        <div class="of-header">
            <span class="of-title">{{ title }}</span>
            @if (productsToShow.length > 1) {
                <span class="of-count">{{ productsToShow.length }}</span>
            }
        </div>
    </ng-template>

    <div class="of-body">

        <!-- ── Message quota de bases/utilisateurs épuisé (offre active) ── -->
        @if (addon_kind) {
            <div class="of-callout warn">
                <p>
                    @if (addon_kind === 'base') {
                        Votre offre actuelle ne permet plus de créer de nouvelle base.
                        Ajoutez un <strong>complément «&nbsp;+1 base&nbsp;»</strong> lié à votre offre
                        pour créditer votre organisation d'une base supplémentaire.
                    } @else {
                        Votre offre actuelle a atteint son nombre d'utilisateurs.
                        Ajoutez un <strong>complément «&nbsp;+1 utilisateur&nbsp;»</strong> lié à votre offre
                        pour inviter un nouveau membre.
                    }
                </p>
            </div>
        }

        <!-- ── Message quota de bases épuisé sans formule (offre Simple) ── -->
        @if (is_simple_offer) {
            <div class="of-callout warn">
                <p>
                    Toutes les bases de votre abonnement sont créées. Souscrivez un
                    <strong>abonnement individuel</strong> ci-dessous : la nouvelle base sera
                    créée automatiquement après le paiement.
                </p>
            </div>
        }

        <!-- ── Message ajout de base (mode abonnement individuel par base) ── -->
        @if (is_add_base) {
            <div class="of-callout info">
                <p>
                    Deux façons d'ajouter une base : souscrire une <strong>formule</strong> qui regroupe
                    l'ensemble de vos bases (souvent plus rentable), ou un <strong>abonnement individuel</strong>
                    par base. Dans les deux cas, la base est créée automatiquement après le paiement.
                </p>
            </div>
        }

        <!-- ── Message ajout de base par abonnement mensuel (sans offre Equipe) ── -->
        @if (is_base_subscription) {
            <div class="of-callout info">
                <p>
                    Sélectionnez l'abonnement mensuel correspondant au type de base choisi{{ base_type === 'encrypted' ? ' (base cryptée)' : '' }}.
                    La base sera créée automatiquement après le paiement.
                </p>
            </div>
        }

        <!-- ── Message organisation à payer (MultiBases) ── -->
        @if (isPaymentRequired) {
            <div class="of-callout info">
                <p>
                    Pour continuer de gérer et créer de nouvelles bases il est nécessaire de souscrire à la formule
                    « Multi-Bases » ci-dessous. Cette dernière inclut 3 bases et vous permet d'en ajouter. Pour en savoir
                    plus sur tous les avantages de cette formule cliquez ici :
                </p>
                <button type="button" class="mk-ubtn" (click)="openMultiBasesInfo()">
                    <i class="pi pi-info-circle"></i> En savoir plus
                </button>
            </div>
        }

        <!-- ── Message crédits épuisés ── -->
        @if (isCreditsRequired) {
            <div class="of-callout warn">
                <p>
                    Vous n'avez plus de NrToks. Rechargez maintenant votre base afin que tous vos outils
                    <a href="https://narratheque.io" target="_blank" rel="noopener">narratheque.io</a>
                    continuent de fonctionner.
                </p>
            </div>
        }

        @if (productsToShow.length) {

            <!-- ── Formules : mêmes cartes que /market et le panier ── -->
            @if (formulaProducts.length) {
                <div class="of-group">
                    <div class="of-group-head">
                        <span class="of-group-label">{{
                            is_simple_offer ? 'Abonnements individuels (offre Simple)'
                            : is_add_base ? 'Formules (regroupement de vos bases)'
                            : 'Formule'
                        }}</span>
                        @if (hasBothPeriods) {
                            <div class="mk-toggle" role="group" aria-label="Période de facturation">
                                <button type="button" [class.on]="period === 'm'" (click)="setPeriod('m')">Mensuel</button>
                                <button type="button" [class.on]="period === 'a'" (click)="setPeriod('a')">
                                    Annuel <span class="save">2 mois offerts</span>
                                </button>
                            </div>
                        }
                    </div>
                    <div class="mk-grid" [class.of-grid-single]="formulaProducts.length === 1">
                        @for (product of formulaProducts; track product.id) {
                            <article class="mk-card" [class.in-cart]="product.added">
                                <div class="mk-card-top">
                                    <div class="mk-title">
                                        <h5 class="mk-name">{{ product.name }}</h5>
                                    </div>
                                    @if (product.is_subscription) {
                                        <span class="mk-tag" [class.yearly]="price.isAnnual(product)">
                                            {{ price.isAnnual(product) ? 'Annuel' : 'Mensuel' }}
                                        </span>
                                    }
                                </div>

                                @if (hasDescription(product)) {
                                    <div class="mk-desc product-description" [innerHTML]="product.description"></div>
                                }

                                <div class="mk-pricing">
                                    <div class="mk-amount">
                                        <span class="big">{{ price.bigPrice(product) }}</span>
                                        <span class="cur" [innerHTML]="'' | currencySymbol"></span>
                                        <span class="unit">{{ price.unit(product) }}</span>
                                    </div>
                                    @if (price.detail(product); as detail) {
                                        <p class="mk-note">{{ detail }}</p>
                                    }
                                    @if (product.credits > 0) {
                                        <span class="mk-credits">
                                            <i class="pi pi-bolt"></i>
                                            + {{ product.credits | formatCredits }} NrToks{{ product.modules?.length ? ' offerts' : '' }}
                                        </span>
                                    }
                                </div>

                                @if (product.added) {
                                    <button type="button" class="mk-cta alt" (click)="handleProductClick(product)">
                                        <i class="pi pi-shopping-cart"></i> Accéder au panier
                                    </button>
                                } @else {
                                    <button type="button" class="mk-cta" (click)="handleProductClick(product)">
                                        {{ ctaLabel(product, 'formula') }}
                                    </button>
                                }
                            </article>
                        }
                    </div>
                </div>
            }

            <!-- ── Abonnements individuels par base (mode ajout de base) ── -->
            @if (baseAbosProducts.length) {
                <div class="of-group">
                    <span class="of-group-label">Abonnements individuels par base</span>
                    <div class="mk-grid" [class.of-grid-single]="baseAbosProducts.length === 1">
                        @for (product of baseAbosProducts; track product.id) {
                            <article class="mk-card" [class.in-cart]="product.added">
                                <div class="mk-card-top">
                                    <div class="mk-title">
                                        <h5 class="mk-name">{{ product.name }}</h5>
                                    </div>
                                    @if (isEncryptedBaseProduct(product)) {
                                        <span class="mk-tag">Cryptée</span>
                                    }
                                    @if (product.is_subscription) {
                                        <span class="mk-tag" [class.yearly]="price.isAnnual(product)">
                                            {{ price.isAnnual(product) ? 'Annuel' : 'Mensuel' }}
                                        </span>
                                    }
                                </div>

                                @if (hasDescription(product)) {
                                    <div class="mk-desc product-description" [innerHTML]="product.description"></div>
                                }

                                <div class="mk-pricing">
                                    <div class="mk-amount">
                                        <span class="big">{{ price.bigPrice(product) }}</span>
                                        <span class="cur" [innerHTML]="'' | currencySymbol"></span>
                                        <span class="unit">{{ price.unit(product) }}</span>
                                    </div>
                                    @if (price.detail(product); as detail) {
                                        <p class="mk-note">{{ detail }}</p>
                                    }
                                </div>

                                @if (product.added) {
                                    <button type="button" class="mk-cta alt" (click)="handleProductClick(product)">
                                        <i class="pi pi-shopping-cart"></i> Accéder au panier
                                    </button>
                                } @else {
                                    <button type="button" class="mk-cta" (click)="handleProductClick(product)">
                                        {{ ctaLabel(product, 'formula') }}
                                    </button>
                                }
                            </article>
                        }
                    </div>
                </div>
            }

            <!-- ── Abonnements complémentaires : mêmes bandes que /market ── -->
            @if (addonProducts.length) {
                <div class="of-group">
                    <div class="of-group-head">
                        <span class="of-group-label">Abonnements complémentaires</span>
                        @if (addon_kind && hasBothPeriods) {
                            <div class="mk-toggle" role="group" aria-label="Période de facturation">
                                <button type="button" [class.on]="period === 'm'" (click)="setPeriod('m')">Mensuel</button>
                                <button type="button" [class.on]="period === 'a'" (click)="setPeriod('a')">
                                    Annuel <span class="save">2 mois offerts</span>
                                </button>
                            </div>
                        }
                    </div>
                    <div class="of-list">
                        @for (product of addonProducts; track product.id) {
                            <div class="mk-plus" [class.in-cart]="product.added">
                                <span class="mk-plus-icon">
                                    <i class="pi" [class]="addonIcon(product)"></i>
                                </span>
                                <div class="mk-plus-body">
                                    <h5 class="mk-plus-title">
                                        {{ product.name }}
                                        <span class="tagp">Complément</span>
                                        @if (addon_kind && hasBothPeriods && product.is_subscription) {
                                            <span class="mk-tag" [class.yearly]="price.isAnnual(product)">
                                                {{ price.isAnnual(product) ? 'Annuel' : 'Mensuel' }}
                                            </span>
                                        }
                                    </h5>
                                    @if (hasDescription(product)) {
                                        <div class="mk-plus-desc product-description" [innerHTML]="product.description"></div>
                                    }
                                    @if (price.detail(product); as detail) {
                                        <p class="mk-note">{{ detail }}</p>
                                    }
                                </div>

                                <div class="mk-plus-side">
                                    <span class="mk-plus-amount">
                                        {{ price.bigPrice(product) }}&nbsp;<span class="cur" [innerHTML]="'' | currencySymbol"></span>
                                        <small>{{ price.unit(product) }}</small>
                                    </span>
                                    <button type="button" class="mk-cta mk-plus-cta" [class.alt]="product.added"
                                        (click)="handleProductClick(product)">
                                        @if (product.added) {
                                            <i class="pi pi-shopping-cart"></i>
                                        }
                                        {{ ctaLabel(product, 'addon') }}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- ── Produits à l'unité (packs de crédits) : mêmes cartes que /market ── -->
            @if (unitProducts.length) {
                <div class="of-group">
                    <span class="of-group-label">Produits à l'unité</span>
                    <div class="mk-ugrid">
                        @for (product of unitProducts; track product.id) {
                            <article class="mk-uitem" [class.in-cart]="product.added">
                                <span class="mk-chipnum">
                                    @if (product.modules?.length) {
                                        @if (product.file_url) {
                                            <img [src]="product.file_url" [alt]="product.name" />
                                        } @else {
                                            <i class="pi pi-box"></i>
                                        }
                                    } @else {
                                        <span class="n">{{ product.credits | formatCredits }}</span>
                                        <span class="l">NrToks</span>
                                    }
                                </span>

                                <div class="mk-uitem-body">
                                    <h5 class="mk-name">{{ product.name }}</h5>
                                    @if (hasDescription(product)) {
                                        <div class="mk-uitem-desc product-description" [innerHTML]="product.description"></div>
                                    }
                                    @if (product.credits > 0 && product.modules?.length) {
                                        <span class="mk-credits"><i class="pi pi-bolt"></i> + {{ product.credits | formatCredits }} NrToks offerts</span>
                                    }

                                    <div class="mk-uprice">
                                        <span class="v">
                                            {{ price.bigPrice(product) }}&nbsp;<span class="cur" [innerHTML]="'' | currencySymbol"></span>
                                            <small>{{ price.unit(product) }}</small>
                                        </span>
                                        <button type="button" class="mk-ubtn" [class.on]="product.added"
                                            (click)="handleProductClick(product)">
                                            @if (product.added) {
                                                <i class="pi pi-shopping-cart"></i>
                                            }
                                            {{ ctaLabel(product, 'unit') }}
                                        </button>
                                    </div>
                                </div>
                            </article>
                        }
                    </div>
                </div>
            }

        } @else if (isLoading) {
            <!-- ── Skeleton de chargement ── -->
            <div class="mk-grid of-grid-single">
                @for (_ of [1, 2]; track _) {
                    <div class="mk-card">
                        <p-skeleton width="60%" height="24px" borderRadius="8px" />
                        <p-skeleton width="90%" height="13px" borderRadius="8px" />
                        <p-skeleton width="75%" height="13px" borderRadius="8px" />
                        <div class="mk-pricing">
                            <p-skeleton width="120px" height="30px" borderRadius="8px" />
                            <p-skeleton width="180px" height="13px" borderRadius="8px" />
                        </div>
                        <p-skeleton height="46px" borderRadius="12px" />
                    </div>
                }
            </div>
        } @else {
            <!-- ── Aucune offre ── -->
            <div class="mk-empty">
                <i class="pi pi-shopping-cart"></i>
                <p>Aucune offre disponible pour le moment.</p>
            </div>
        }
    </div>
</p-dialog>
